import { useEffect } from 'react';
import { CheckCircle, Heart } from 'lucide-react';

function SuccessScreen({ event, onReset }) {
  useEffect(() => {
    // Auto-reset after 8 seconds
    const timer = setTimeout(() => {
      onReset();
    }, 8000);

    return () => clearTimeout(timer);
  }, [onReset]);

  return (
    <div className="fullscreen flex items-center justify-center bg-gradient-to-br from-dark-slate via-dark-slate to-gold/20 p-8">
      <div className="text-center animate-fadeIn">
        {/* Success Icon */}
        <div className="relative inline-block mb-8">
          <div className="w-32 h-32 bg-gold rounded-full flex items-center justify-center shadow-2xl shadow-gold/50 animate-bounce">
            <CheckCircle className="w-16 h-16 text-dark-slate" />
          </div>
          <div className="absolute -top-2 -right-2">
            <Heart className="w-12 h-12 text-crimson animate-pulse" fill="currentColor" />
          </div>
        </div>

        {/* Success Message */}
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Thank You!
        </h1>

        <div className="max-w-2xl mx-auto space-y-4 mb-8">
          {event.thanksMessage ? (
            <p className="text-2xl text-neutral-grey-200 leading-relaxed">
              {event.thanksMessage}
            </p>
          ) : (
            <>
              <p className="text-2xl text-neutral-grey-200">
                Your message has been successfully uploaded!
              </p>
              <p className="text-xl text-gold">
                {event.hostName} will treasure your video forever.
              </p>
            </>
          )}
        </div>

        {/* Action Area */}
        <div className="flex flex-col items-center">
          {/* Primary CTA Button */}
          <button
            onClick={onReset}
            className="w-full max-w-sm px-12 py-5 bg-[#D4AF37] hover:bg-gold-light text-dark-slate font-bold text-xl rounded-xl transition-colors duration-200 shadow-lg shadow-gold/20"
          >
            Record Another Message
          </button>

          {/* Social Proof - Video Count */}
          <p className="text-neutral-grey-400 text-sm mt-3">
            Join {event.videoCount} others who left a message!
          </p>
        </div>

        {/* Auto-reset message */}
        <p className="text-neutral-grey-500 mt-8 text-xs">
          Returning to home in a few seconds...
        </p>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out;
        }
      `}</style>
    </div>
  );
}

export default SuccessScreen;
